export default function RatesApi({ makeRequest, buildRequest, baseUrl = '' }) {

    function getWinzRates() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/winzrate`));
        });
    }

    function getWinzRateById(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/winzrate/${id}`));
        });
    }

    function updateWinzRate(data) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/winzrate/upsert`, data));
        });
    }

    function deleteWinzRate(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/winzrate/${id}`));
        });
    }

    return {
        getWinzRates,
        getWinzRateById,
        updateWinzRate,
        deleteWinzRate
    }

}